import $ from "jquery";

const $body = $("body");
const $btnSearch = $(".js--toggle-search");
const $inputSearch = $("#searchform-header-input");

// Make sure focused input cursor is at the end of existing text
$inputSearch.on("focus", function () {
  var that = this;

  setTimeout(function () {
    that.selectionStart = that.selectionEnd = that.value.length;
  }, 1);
});

const setFocusState = () =>
  $body.is(".is--search-open")
    ? $inputSearch.trigger("focus")
    : $inputSearch.trigger("blur");

export const openSearch = () => {
  $body.addClass("is--search-open");
  setFocusState();
};

export const closeSearch = () => {
  $body.removeClass("is--search-open");
  setFocusState();
};

export const toggleSearch = () => {
  $body.toggleClass("is--search-open");
  setFocusState();
};

$btnSearch.on("click", toggleSearch);
